import { render, staticRenderFns } from "./UserTransferCount.vue?vue&type=template&id=4a22a388&scoped=true&"
import script from "./UserTransferCount.vue?vue&type=script&lang=js&"
export * from "./UserTransferCount.vue?vue&type=script&lang=js&"
import style0 from "./UserTransferCount.vue?vue&type=style&index=0&id=4a22a388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22a388",
  null
  
)

export default component.exports